import * as React from "react";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import Slider from "@mui/material/Slider";
import { ASSETS } from "../../utils/config";
import styled from "styled-components";

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const Title = styled(Typography)`
  font-size: 12px;
  font-family: "DM Sans";
  font-weight: 400;
`;

const Label = styled(Typography)`
  font-size: 10px;
  color: #bbbbbb;
  font-family: "DM Sans";
`;

const InfoIcon = styled.img`
  width: 12px;
  height: 12px;
  cursor: pointer;
`;

const InfoIcon2 = styled.img`
  width: 15px;
  height: 15px;
  cursor: pointer;
`;

const InfoWrapper = styled.div`
  position: absolute;
  width: 200px;
  min-height: 80px;
  background-color: white;
  border-radius: 10px;
  padding: 10px;
  right: -140px;
  margin-top: -100px;
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.1);
`;

const InfoText = styled(Typography)`
  font-size: 12px;
`;

export default function CustomSlider({
  label,
  steps,
  min,
  max,
  onChange,
  infoText,
  value,
}) {
  const [showInfo, setShowInfo] = React.useState(false);

  return (
    <Box style={{ width: "100%", padding: 10 }}>
      <Row>
        <Title>{label}</Title>
        <InfoIcon
          onMouseOver={() => setShowInfo(true)}
          src={ASSETS.infoIcon}
          onMouseOut={() => setShowInfo(false)}
        />
        {showInfo ? (
          <InfoWrapper>
            <InfoIcon2 src={ASSETS.info2} />
            <InfoText>{infoText}</InfoText>
          </InfoWrapper>
        ) : null}
      </Row>
      <Slider
        valueLabelDisplay="auto"
        value={value}
        onChange={onChange}
        step={steps}
        marks
        min={min}
        max={max}
        size="small"
        style={{
          color: "#123051",
          height: 4,
          padding: 0,
        }}
      />
      <Row>
        <Label>Less</Label>
        <Label>More</Label>
      </Row>
    </Box>
  );
}
